export const barDividerTestId = 'barDividerTestId';
